export enum GenericTrackTypes {
  LINK_PRESSED = 'Link Pressed',
  BUTTON_PRESSED = 'Button Pressed',
  BACK_BUTTON_PRESSED = 'Back Button Pressed',
  OPTION_SELECTED = 'Option Selected',
  CHECKBOX_SELECTED = 'Checkbox Selected',
  TAB_NAVIGATION = 'Tab navigation',
  SLIDE = 'Slide',
  TYPING = 'Typing',
}
